import { QueryClient, QueryClientProvider } from 'react-query'
import React from 'react';
import ReactDOM from "react-dom/client";
import DetailsSheetContextProvider from "./context/detailsSheetContext";
import MobileButtonContainer from "./components/MobileButtonContainer";
import UiContextProvider from "./context/uiContext";
import LocationMaps from "./components/LocationMap/locationMaps";
import AquaSheetContextProvider from "./context/aquaSheetContext";
import AquaSheetShopContainer from "./components/AquaSheetShopContainer";
import {SHOPS_BY_BRAND_CONTAINER_ID} from "./constants";
import MobileShopListContainer from "./components/MobileShopListContainer";

// Create a client
const queryClient = new QueryClient();

const App =  () => {


  console.debug('Launch react app');
  const speciesSheetEl = document.getElementById('ajaxPartnerShop');
  const shopsByBrandEl = document.getElementById(SHOPS_BY_BRAND_CONTAINER_ID);

  return (
      <QueryClientProvider client={queryClient}>
          <UiContextProvider>
              <LocationMaps/>

              { !! shopsByBrandEl &&
                  <AquaSheetContextProvider brand={shopsByBrandEl.dataset?.brand} gtmClassName={shopsByBrandEl.dataset?.gtmClass}>
                      <AquaSheetShopContainer/>
                  </AquaSheetContextProvider>
              }

              { !!speciesSheetEl &&
                  <DetailsSheetContextProvider formula={speciesSheetEl.dataset?.formula ? speciesSheetEl.dataset.formula : 'f_one'} gtmClassName={[...speciesSheetEl.classList].find(className => className.startsWith('gtm'))} >
                      <MobileButtonContainer/>
                      <MobileShopListContainer />
                  </DetailsSheetContextProvider>
              }
          </UiContextProvider>
      </QueryClientProvider>
  )
}

ReactDOM.createRoot(document.getElementById("root")).render(<App />);